import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import BackToTop from './BackToTop';

const Layout = ({ children }) => (
  <>
    {/* Scroll automatique en haut lors du changement de page */}
    <ScrollToTop />
    
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      <Header />
      <main style={{
        flex: '1',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {children}
      </main>
      <Footer />
    </div>
    
    {/* Bouton "Retour en haut" */}
    <BackToTop />
  </>
);

export default Layout;